export const ITEMSUMMARY_GETREPORT = 'ITEMSUMMARY_GETREPORT';
export const ITEMSUMMARY_FETCHING = 'ITEMSUMMARY_FETCHING';
export const ITEMSUMMARY_FETCHERROR = 'ITEMSUMMARY_FETCHERROR';
export const ITEMSUMMARY_CLEARREPORT = 'ITEMSUMMARY_CLEARREPORT';



// WEBPACK FOOTER //
// ./src/pages/itemsummary/state/types.js